import { defineStore } from 'pinia';

export const useWalletStore = defineStore('wallet', {
  state: () => {
    return {
      evmWalletLabel: '',
      metamaskNetwork: '',
      tpWalletNetwork: '', // 存一个tp钱包连接的network
      walletInfo: {},
    };
  },
  actions: {
    changeMode(payload) {
      this.isDark = payload;
    },
  },
  getters: {
    // doubledCount: (state) => {
    //   return state.isDark;
    // },
  },
});
